export default __webpack_public_path__ + "images/ffec3737075d6404cb7244b912524284.png";